import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout'; 
import { states } from '../states'; 
import { countries } from '../countries'; 
import { useNavigate } from 'react-router-dom';
import { useAuth } from './StoreValue';
import { markStepComplete } from './StepGuard';
import { isPromotix } from '../utils/agentConfig';
const CorporateInfoForm = ({ onNext }) => {
    const [corporateInfo, setCorporateInfo] = useState({
        legalName: '',
        federalTaxId: '',
        address: '',
        city: '',
        region: '',
        postal: '',
        country: 'USA',
        phone: '',
    });

    const [copyClientInfo, setCopyClientInfo] = useState(false);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const { ContactGuid,agentIdVal,leadGuid, updateAgentId, updateContactGuid, updateLeadGuid } = useAuth();
    //const corporateInfo = '';
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);  // Add loading state
    const navigate = useNavigate();
 const [federalTaxIderrors, federalTaxIdsetErrors] = useState({ federalTaxId: '' });

 const handleBlur = (e) => {
    const { name, value } = e.target;

    if (name === 'federalTaxId') {
      let error = '';

      if (value.includes('-')) {
        error = 'Federal Tax ID should not contain a dash (-).';
      } else if (!/^\d+$/.test(value)) {
        error = 'Federal Tax ID must contain only numbers.';
      } else if (value.length !== 9) {
        error = 'Federal Tax ID must be exactly 9 digits long.';
      }

      federalTaxIdsetErrors((prev) => ({
        ...prev,
        federalTaxId: error,
      }));
    }
  };
    const handleChange = (e) => {
        const { name, value } = e.target;
        // Promotix: ZIP/postal is restricted to 5 digits — strip non-digits and cap length as typed.
        const v = (name === 'postal' && isPromotix(agentIdVal))
            ? value.replace(/\D/g, '').slice(0, 5)
            : value;
        setCorporateInfo({
            ...corporateInfo,
            [name]: v,
        });
        federalTaxIdsetErrors((prev) => ({ ...prev, [name]: '' }));
    };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setCopyClientInfo(isChecked);
    
        if (isChecked) {
            const fetchLeadData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/Auth/LeadLookup`, {
                params: {
                    leadGuidVal: leadGuid,
                    agentIdValue: agentIdVal,
                    // Pass leadGuid here
                },
                });
                const leadData = response.data;
                const leadLookupresponseCode = leadData.result.responseCode;
    
                if (leadLookupresponseCode === '00') {
                    const corporateInfo = leadData.queryResponse.clientInfo;
    
                    setCorporateInfo((prevCorporateInfo) => ({
                        ...prevCorporateInfo,
                        legalName: corporateInfo.dba || '',
                        address: corporateInfo.address || '',
                        city: corporateInfo.city || '',
                        region: corporateInfo.region || '',
                        postal: corporateInfo.postal || '',
                        country: corporateInfo.country || 'USA',
                        phone: corporateInfo.phone || '',
                    }));
                }
            } catch (error) {
                console.error('Error fetching lead data:', error);
            }
        };
    
        fetchLeadData();
        }
    };
    useEffect(() => {
        const fetchLeadData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/Auth/LeadLookup`, {
                params: {
                    leadGuidVal: leadGuid,
                    agentIdValue: agentIdVal,
                    // Pass leadGuid here
                },
                });
                const leadData = response.data;
                const leadLookupresponseCode = leadData.result.responseCode;
    
                if (leadLookupresponseCode === '00') {
                    const corporateInfo = leadData.queryResponse.corporate;
    
                    // Update the state with the fetched data
                    setCorporateInfo({
                        legalName: corporateInfo.legalName || '',
                        federalTaxId: corporateInfo.federalTaxId || '',
                        address: corporateInfo.address || '',
                        city: corporateInfo.city || '',
                        region: corporateInfo.region || '',
                        postal: corporateInfo.postal || '',
                        country: corporateInfo.country || 'USA',
                        phone: corporateInfo.phone || '',
                    });
                }
            } catch (error) {
                console.error('Error fetching lead data:', error);
            }
        };
    
        fetchLeadData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');
        if (!leadGuid) {
            setErrorMessage('Session expired or lead data is missing. Please start over from the login page.');
            return;
        }
        setLoading(true);
        // Check for required fields
        const missingFields = [];
        if (!corporateInfo.legalName) missingFields.push('Legal Name');
        if (!corporateInfo.federalTaxId) missingFields.push('Federal Tax ID');
        if (!corporateInfo.address) missingFields.push('Address');
        if (!corporateInfo.city) missingFields.push('City');
        if (!corporateInfo.region) missingFields.push('State');
        if (!corporateInfo.postal) missingFields.push('Postal');
        if (!corporateInfo.phone) missingFields.push('Phone');
        if (!corporateInfo.country) missingFields.push('Country'); // Ensure country is also required
      
        if (missingFields.length > 0) {
          setErrorMessage(`Please fill in the following required fields: ${missingFields.join(', ')}`);
          setLoading(false);
          return; // Stop form submission
        }

        // Check for Federal Tax ID errors
        if (federalTaxIderrors.federalTaxId) {
          setErrorMessage(federalTaxIderrors.federalTaxId);
          setLoading(false);
          return; // Stop form submission
        }

        // Check for Phone number errors
        if (phoneError) {
          setErrorMessage(phoneError);
          setLoading(false);
          return; // Stop form submission
        }

        // Promotix: ZIP/postal must be exactly 5 digits.
        if (isPromotix(agentIdVal) && !/^\d{5}$/.test(corporateInfo.postal)) {
          setErrorMessage('ZIP code must be exactly 5 digits');
          setLoading(false);
          return;
        }
      
        const data = {
        leadguidVal: leadGuid,
        agentId: agentIdVal,
        ContactGuidVal:ContactGuid,
          Detail: {
            TranType: "TranType",
            TranAction: "TranAction",
            Ip: 'Ip'
          },
          Corporate: {
            legalName: corporateInfo.legalName,
            federalTaxId: corporateInfo.federalTaxId,
            address: corporateInfo.address,
            city: corporateInfo.city,
            region: corporateInfo.region,
            postal: corporateInfo.postal,
            country: corporateInfo.country,
            phone: formatPhoneNumber(corporateInfo.phone)
          }
        };
      
        try {
          const response = await axios.post(`${API_BASE_URL}/api/Auth/LeadModify`, data);
          var responseCode = response.data.response.result.responseCode;
          var errorInfo = response.data.response.result?.debugInfo;
      
          if (responseCode === '00' || responseCode === 'X7') {
            markStepComplete('corporateInfo');
            navigate('/ContactInfo');
          } else {
            setErrorMessage(errorInfo);
          }
        } catch (error) {
          console.error('Error submitting form:', error);
          const serverMsg = error.response?.data?.message || error.response?.data || error.message;
          setErrorMessage(typeof serverMsg === 'string' ? serverMsg : 'An unexpected error occurred. Please try again.');
        }finally {
        setLoading(false);  // SStop loading after response
    }
      };

    const [phoneError, setPhoneError] = useState('');

    // Phone number formatting function
    const formatPhoneNumber = (phone) => {
        // Remove all non-digit characters
        const digits = phone.replace(/\D/g, '');
        
        // Format phone number with dashes if it has 10 digits
        if (digits.length === 10) {
            return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
        return phone; // Return as is if not 10 digits
    };
    const handlePhoneBlur = () => {
        const formattedPhone = formatPhoneNumber(corporateInfo.phone);
        setCorporateInfo({ ...corporateInfo, phone: formattedPhone });

        // Validate if phone number has 10 digits
        const digits = corporateInfo.phone.replace(/\D/g, '');
        if (digits.length !== 10) {
            setPhoneError('Phone number must contain exactly 10 digits with format with 711-111-1111');
        } else {
            setPhoneError('');
        }
    };
   
    return (
        <div>
            <Layout pageTitle="Corporate Information">
                <div id="copyCorporate"
                        >
                    <input
                        type="checkbox"
                        className='checkbox_Control'
                        checked={copyClientInfo}
                        onChange={handleCheckboxChange}
                    />
                    <span style={{ marginLeft: '8px' }}>Copy Client Info to Corporate Info</span>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <label className='label_Control' htmlFor="legalName">Corporate/Legal Name <span style={{ color: 'red', display: 'contents' }}>*</span></label>
                            <input
                                type="text"
                                className="form-controling"
                                id="legalName"
                                name="legalName"
                                value={corporateInfo.legalName}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-md-4">
                        <label className='label_Control' htmlFor="federalTaxId">
        Federal Tax ID <span style={{ color: 'red' }}>*</span>
      </label>

      <input
        type="text"
        className={`form-control ${
            federalTaxIderrors.federalTaxId ? 'is-invalid' : ''
        }`}
        id="federalTaxId"
        name="federalTaxId"
        value={corporateInfo.federalTaxId}
        onChange={handleChange}
        onBlur={handleBlur}
        maxLength={9}
        required
      />

      {federalTaxIderrors.federalTaxId && (
        <div className="invalid-feedback">{federalTaxIderrors.federalTaxId}</div>
      )}
                        </div>
                        <div className="col-md-4">
                            <label className='label_Control' htmlFor="phone">Phone <span style={{ color: 'red', display: 'contents' }}>*</span></label>
                            <input
                                type="text"
                                className="form-controling"
                                id="phone"
                                name="phone"
                                value={corporateInfo.phone}
                                onChange={handleChange}
                                onBlur={handlePhoneBlur} // Add onBlur event
                                required
                            />
                            {phoneError && <p style={{ color: 'red' }}>{phoneError}</p>} {/* Display phone error */}
                         </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label className='label_Control' htmlFor="country">Country <span style={{ color: 'red', display: 'contents' }}>*</span></label>
                            <select
                                id="country"
                                className="form-controling"
                                name="country"
                                value={corporateInfo.country}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select a country</option>
                                {countries.map((country) => (
                                    <option
                                        key={country.abbreviation}
                                        value={country.abbreviation}
                                    >
                                        {country.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label className='label_Control' htmlFor="city">City <span style={{ color: 'red', display: 'contents' }}>*</span></label>
                            <input
                                type="text"
                                className="form-controling"
                                id="city"
                                name="city"
                                value={corporateInfo.city}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-md-4">
                            <label className='label_Control' htmlFor="region">State <span style={{ color: 'red', display: 'contents' }}>*</span></label>
                            <select
                                id="region"
                                className="form-controling"
                                name="region"
                                value={corporateInfo.region}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select a state</option>
                                {states.map((state) => (
                                    <option
                                        key={state.abbreviation}
                                        value={state.abbreviation}
                                    >
                                        {state.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label className='label_Control' htmlFor="address">Address <span style={{ color: 'red', display: 'contents' }}>*</span></label>
                            <input
                                type="text"
                                className="form-controling"
                                id="address"
                                name="address"
                                value={corporateInfo.address}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="col-md-4">
                            <label className='label_Control' htmlFor="postal">Postal <span style={{ color: 'red', display: 'contents' }}>*</span></label>
                            <input
                                type="text"
                                className="form-controling"
                                id="postal"
                                name="postal"
                                value={corporateInfo.postal}
                                onChange={handleChange}
                                {...(isPromotix(agentIdVal) ? { maxLength: 5, inputMode: 'numeric' } : {})}
                                required
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
    <button type="submit" className="btn btn-success px-5" style={{ width: '370px' }}>
        Next
    </button>
</div>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    {successMessage && <p className="success-message">{successMessage}</p>}
                    <p style={{ color: 'red' }}>* Required field</p>
                </form>
            </Layout>
        </div>
    );
    
};

export default CorporateInfoForm;
    
